// source: pbtypes/gen/skills/beacon_steering_control_scheme_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.BeaconSteeringControlSchemeParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.BeaconSteeringControlSchemeParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.BeaconSteeringControlSchemeParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.BeaconSteeringControlSchemeParams.displayName = 'proto.skills.BeaconSteeringControlSchemeParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.BeaconSteeringControlSchemeParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.BeaconSteeringControlSchemeParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.BeaconSteeringControlSchemeParams.toObject = function(includeInstance, msg) {
  var f, obj = {
forwardSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
ascendSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
descendSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
yawRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
startingSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
yawRateDeadzone: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
forwardSpeedDeadzone: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
gimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.BeaconSteeringControlSchemeParams}
 */
proto.skills.BeaconSteeringControlSchemeParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.BeaconSteeringControlSchemeParams;
  return proto.skills.BeaconSteeringControlSchemeParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.BeaconSteeringControlSchemeParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.BeaconSteeringControlSchemeParams}
 */
proto.skills.BeaconSteeringControlSchemeParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setForwardSpeed(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAscendSpeed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDescendSpeed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYawRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStartingSpeed(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYawRateDeadzone(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setForwardSpeedDeadzone(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGimbalPitch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.BeaconSteeringControlSchemeParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.BeaconSteeringControlSchemeParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.BeaconSteeringControlSchemeParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getForwardSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getAscendSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDescendSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getYawRate();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getStartingSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getYawRateDeadzone();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getForwardSpeedDeadzone();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getGimbalPitch();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
};


/**
 * optional double forward_speed = 1;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getForwardSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setForwardSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double ascend_speed = 2;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getAscendSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setAscendSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double descend_speed = 3;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getDescendSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setDescendSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double yaw_rate = 4;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getYawRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setYawRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double starting_speed = 5;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getStartingSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setStartingSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double yaw_rate_deadzone = 6;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getYawRateDeadzone = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setYawRateDeadzone = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double forward_speed_deadzone = 7;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getForwardSpeedDeadzone = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setForwardSpeedDeadzone = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double gimbal_pitch = 8;
 * @return {number}
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.getGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.BeaconSteeringControlSchemeParams} returns this
 */
proto.skills.BeaconSteeringControlSchemeParams.prototype.setGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


goog.object.extend(exports, proto.skills);
